import { CanActivateFn } from '@angular/router';

export const privatePagesGuard: CanActivateFn = () => {
    return true;
};
